function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @module ol/renderer/canvas/TileLayer
 */
import CanvasLayerRenderer from './Layer.js';
import DataTile, { asImageLike } from '../../DataTile.js';
import ImageTile from '../../ImageTile.js';
import LRUCache from '../../structs/LRUCache.js';
import ReprojDataTile from '../../reproj/DataTile.js';
import ReprojTile from '../../reproj/Tile.js';
import TileRange from '../../TileRange.js';
import TileState from '../../TileState.js';
import { apply as applyTransform, compose as composeTransform } from '../../transform.js';
import { ascending } from '../../array.js';
import { containsCoordinate, createEmpty, equals, getIntersection, getTopLeft, intersects } from '../../extent.js';
import { createOrUpdate as createTileCoord, getKeyZXY } from '../../tilecoord.js';
import { fromUserExtent } from '../../proj.js';
import { getUid } from '../../util.js';
import { toSize } from '../../size.js';
/**
 * @param {string} sourceKey The source key.
 * @param {number} z The tile z level.
 * @param {number} x The tile x level.
 * @param {number} y The tile y level.
 * @return {string} The cache key.
 */

function getCacheKey(sourceKey, z, x, y) {
  return "".concat(sourceKey, ",").concat(getKeyZXY(z, x, y));
}
/**
 * @typedef {Object<number, Set<import("../../Tile.js").default>>} TileLookup
 */

/**
 * Add a tile to the lookup.
 * @param {TileLookup} tilesByZ Lookup of tiles by zoom level.
 * @param {import("../../Tile.js").default} tile A tile.
 * @param {number} z The zoom level.
 * @return {boolean} The tile was added to the lookup.
 */


function addTileToLookup(tilesByZ, tile, z) {
  if (!(z in tilesByZ)) {
    tilesByZ[z] = new Set([tile]);
    return true;
  }

  var set = tilesByZ[z];
  var existing = set.has(tile);

  if (!existing) {
    set.add(tile);
  }

  return !existing;
}
/**
 * Remove a tile from the lookup.
 * @param {TileLookup} tilesByZ Lookup of tiles by zoom level.
 * @param {import("../../Tile.js").default} tile A tile.
 * @param {number} z The zoom level.
 * @return {boolean} The tile was removed from the lookup.
 */


function removeTileFromLookup(tilesByZ, tile, z) {
  var set = tilesByZ[z];

  if (set) {
    return set.delete(tile);
  }

  return false;
}
/**
 * @param {import("../../Map.js").FrameState} frameState Frame state.
 * @param {import("../../extent.js").Extent} extent The frame extent.
 * @return {import("../../extent.js").Extent} Frame extent intersected with layer extents.
 */


function getRenderExtent(frameState, extent) {
  var layerState = frameState.layerStatesArray[frameState.layerIndex];

  if (layerState.extent) {
    extent = getIntersection(extent, fromUserExtent(layerState.extent, frameState.viewState.projection));
  }

  var source =
  /** @type {import("../../source/Tile.js").default} */
  layerState.layer.getRenderSource();

  if (!source.getWrapX()) {
    var gridExtent = source.getTileGridForProjection(frameState.viewState.projection).getExtent();

    if (gridExtent) {
      extent = getIntersection(extent, gridExtent);
    }
  }

  return extent;
}
/**
 * @typedef {Object} Options
 * @property {number} [cacheSize=512] The cache size.
 */

/**
 * @classdesc
 * Canvas renderer for tile layers.
 * @api
 * @template {import("../../layer/Tile.js").default|import("../../layer/VectorTile.js").default} [LayerType=import("../../layer/Tile.js").default<import("../../source/Tile.js").default>|import("../../layer/VectorTile.js").default]
 * @extends {CanvasLayerRenderer<LayerType>}
 */


var CanvasTileLayerRenderer = /*#__PURE__*/function (_CanvasLayerRenderer) {
  _inherits(CanvasTileLayerRenderer, _CanvasLayerRenderer);

  var _super = _createSuper(CanvasTileLayerRenderer);

  /**
   * @param {LayerType} tileLayer Tile layer.
   * @param {Options} [options] Options.
   */
  function CanvasTileLayerRenderer(tileLayer, options) {
    var _this;

    _classCallCheck(this, CanvasTileLayerRenderer);

    _this = _super.call(this, tileLayer);
    options = options || {};
    /**
     * Rendered extent has changed since the previous `renderFrame()` call
     * @type {boolean}
     */

    _this.extentChanged = true;
    /**
     * The last call to `renderFrame` was completed with all tiles loaded
     * @type {boolean}
     */

    _this.renderComplete = false;
    /**
     * @private
     * @type {?import("../../extent.js").Extent}
     */

    _this.renderedExtent_ = null;
    /**
     * @protected
     * @type {number}
     */

    _this.renderedPixelRatio;
    /**
     * @protected
     * @type {import("../../proj/Projection.js").default}
     */

    _this.renderedProjection = null;
    /**
     * @protected
     * @type {number}
     */

    _this.renderedRevision;
    /**
     * @protected
     * @type {!Array<import("../../Tile.js").default>}
     */

    _this.renderedTiles = [];
    /**
     * @private
     * @type {string}
     */

    _this.renderedSourceKey_;
    /**
     * @private
     * @type {number}
     */

    _this.renderedSourceRevision_;
    /**
     * @protected
     * @type {import("../../extent.js").Extent}
     */

    _this.tempExtent = createEmpty();
    /**
     * @private
     * @type {import("../../TileRange.js").default}
     */

    _this.tempTileRange_ = new TileRange(0, 0, 0, 0);
    /**
     * @type {import("../../tilecoord.js").TileCoord}
     * @private
     */

    _this.tempTileCoord_ = createTileCoord(0, 0, 0);
    var cacheSize = options.cacheSize !== undefined ? options.cacheSize : 512;
    /**
     * @type {import("../../structs/LRUCache.js").default<import("../../Tile.js").default>}
     * @private
     */

    _this.tileCache_ = new LRUCache(cacheSize);
    /**
     * @private
     * @type {import("../../proj/Projection.js").default}
     */

    _this.renderedProjection_ = undefined;
    _this.maxStaleKeys = cacheSize * 0.5;
    return _this;
  }
  /**
   * @return {LRUCache} Tile cache.
   */


  _createClass(CanvasTileLayerRenderer, [{
    key: "getTileCache",
    value: function getTileCache() {
      return this.tileCache_;
    }
    /**
     * Get a tile from the cache or create one if needed.
     *
     * @param {number} z Tile coordinate z.
     * @param {number} x Tile coordinate x.
     * @param {number} y Tile coordinate y.
     * @param {import("../../Map.js").FrameState} frameState Frame state.
     * @return {import("../../Tile.js").default|null} Tile (or null if outside source extent).
     * @protected
     */

  }, {
    key: "getOrCreateTile",
    value: function getOrCreateTile(z, x, y, frameState) {
      var tileCache = this.tileCache_;
      var tileLayer = this.getLayer();
      var tileSource = tileLayer.getSource();
      var cacheKey = getCacheKey(tileSource.getKey(), z, x, y);
      /** @type {import("../../Tile.js").default} */

      var tile;

      if (tileCache.containsKey(cacheKey)) {
        tile = tileCache.get(cacheKey);
      } else {
        tile = tileSource.getTile(z, x, y, frameState.pixelRatio, frameState.viewState.projection);

        if (!tile) {
          return null;
        }

        tileCache.set(cacheKey, tile);
      }

      return tile;
    }
    /**
     * @param {number} z Tile coordinate z.
     * @param {number} x Tile coordinate x.
     * @param {number} y Tile coordinate y.
     * @param {import("../../Map.js").FrameState} frameState Frame state.
     * @return {import("../../Tile.js").default|null} Tile (or null if outside source extent).
     * @protected
     */

  }, {
    key: "getTile",
    value: function getTile(z, x, y, frameState) {
      var tile = this.getOrCreateTile(z, x, y, frameState);

      if (!tile) {
        return null;
      }

      return tile;
    }
    /**
     * @param {import("../../pixel.js").Pixel} pixel Pixel.
     * @return {Uint8ClampedArray} Data at the pixel location.
     * @override
     */

  }, {
    key: "getData",
    value: function getData(pixel) {
      var frameState = this.frameState;

      if (!frameState) {
        return null;
      }

      var layer = this.getLayer();
      var coordinate = applyTransform(frameState.pixelToCoordinateTransform, pixel.slice());
      var layerExtent = layer.getExtent();

      if (layerExtent) {
        if (!containsCoordinate(layerExtent, coordinate)) {
          return null;
        }
      }

      var viewState = frameState.viewState;
      var source = layer.getRenderSource();
      var tileGrid = source.getTileGridForProjection(viewState.projection);
      var tilePixelRatio = source.getTilePixelRatio(frameState.pixelRatio);

      for (var z = tileGrid.getZForResolution(viewState.resolution); z >= tileGrid.getMinZoom(); --z) {
        var tileCoord = tileGrid.getTileCoordForCoordAndZ(coordinate, z);
        var tile = this.getTile(z, tileCoord[1], tileCoord[2], frameState);

        if (!tile || tile.getState() !== TileState.LOADED) {
          continue;
        }

        var tileOrigin = tileGrid.getOrigin(z);
        var tileSize = toSize(tileGrid.getTileSize(z));
        var tileResolution = tileGrid.getResolution(z);
        /**
         * @type {import('../../DataTile.js').ImageLike}
         */

        var image = void 0;

        if (tile instanceof ImageTile || tile instanceof ReprojTile) {
          image = tile.getImage();
        } else if (tile instanceof DataTile) {
          image = asImageLike(tile.getData());

          if (!image) {
            continue;
          }
        } else {
          continue;
        }

        var col = Math.floor(tilePixelRatio * ((coordinate[0] - tileOrigin[0]) / tileResolution - tileCoord[1] * tileSize[0]));
        var row = Math.floor(tilePixelRatio * ((tileOrigin[1] - coordinate[1]) / tileResolution - tileCoord[2] * tileSize[1]));
        var gutter = Math.round(tilePixelRatio * source.getGutterForProjection(viewState.projection));
        return this.getImageData(image, col + gutter, row + gutter);
      }

      return null;
    }
    /**
     * Determine whether render should be called.
     * @param {import("../../Map.js").FrameState} frameState Frame state.
     * @return {boolean} Layer is ready to be rendered.
     * @override
     */

  }, {
    key: "prepareFrame",
    value: function prepareFrame(frameState) {
      if (!this.renderedProjection_) {
        this.renderedProjection_ = frameState.viewState.projection;
      } else if (frameState.viewState.projection !== this.renderedProjection_) {
        this.tileCache_.clear();
        this.renderedProjection_ = frameState.viewState.projection;
      }

      var source = this.getLayer().getSource();

      if (!source) {
        return false;
      }

      var sourceRevision = source.getRevision();

      if (!this.renderedRevision_) {
        this.renderedRevision_ = sourceRevision;
      } else if (this.renderedRevision_ !== sourceRevision) {
        this.renderedRevision_ = sourceRevision;

        if (this.renderedSourceKey_ === source.getKey()) {
          this.tileCache_.clear();
        }
      }

      return true;
    }
    /**
     * @param {import("../../Map.js").FrameState} frameState Frame state.
     * @param {import("../../extent.js").Extent} extent The extent to be rendered.
     * @param {number} initialZ The zoom level.
     * @param {TileLookup} tilesByZ Lookup of tiles by zoom level.
     * @param {number} preload Number of additional levels to load.
     */

  }, {
    key: "enqueueTiles",
    value: function enqueueTiles(frameState, extent, initialZ, tilesByZ, preload) {
      var viewState = frameState.viewState;
      var tileLayer = this.getLayer();
      var tileSource = tileLayer.getRenderSource();
      var tileGrid = tileSource.getTileGridForProjection(viewState.projection);
      var tileSourceKey = getUid(tileSource);

      if (!(tileSourceKey in frameState.wantedTiles)) {
        frameState.wantedTiles[tileSourceKey] = {};
      }

      var wantedTiles = frameState.wantedTiles[tileSourceKey];
      var map = tileLayer.getMapInternal();
      var minZ = Math.max(initialZ - preload, tileGrid.getMinZoom(), tileGrid.getZForResolution(Math.min(tileLayer.getMaxResolution(), map ? map.getView().getResolutionForZoom(Math.max(tileLayer.getMinZoom(), 0)) : tileGrid.getResolution(0)), tileSource.zDirection));

      for (var z = initialZ; z >= minZ; --z) {
        var tileRange = tileGrid.getTileRangeForExtentAndZ(extent, z, this.tempTileRange_);
        var tileResolution = tileGrid.getResolution(z);

        for (var x = tileRange.minX; x <= tileRange.maxX; ++x) {
          for (var y = tileRange.minY; y <= tileRange.maxY; ++y) {
            var tile = this.getTile(z, x, y, frameState);

            if (!tile) {
              continue;
            }

            var added = addTileToLookup(tilesByZ, tile, z);

            if (!added) {
              continue;
            }

            var tileQueueKey = tile.getKey();
            wantedTiles[tileQueueKey] = true;

            if (tile.getState() === TileState.IDLE) {
              if (!frameState.tileQueue.isKeyQueued(tileQueueKey)) {
                var tileCoord = createTileCoord(z, x, y, this.tempTileCoord_);
                frameState.tileQueue.enqueue([tile, tileSourceKey, tileGrid.getTileCoordCenter(tileCoord), tileResolution]);
              }
            }
          }
        }
      }
    }
    /**
     * Look for tiles covering the provided tile coordinate at an alternate
     * zoom level.  Loaded tiles will be added to the provided tile texture lookup.
     * @param {import("../../tilecoord.js").TileCoord} tileCoord The target tile coordinate.
     * @param {TileLookup} tilesByZ Lookup of tiles by zoom level.
     * @return {boolean} The tile coordinate is covered by loaded tiles at the alternate zoom level.
     * @private
     */

  }, {
    key: "findStaleTile_",
    value: function findStaleTile_(tileCoord, tilesByZ) {
      var tileCache = this.tileCache_;
      var z = tileCoord[0];
      var x = tileCoord[1];
      var y = tileCoord[2];
      var staleKeys = this.getStaleKeys();

      for (var i = 0; i < staleKeys.length; ++i) {
        var cacheKey = getCacheKey(staleKeys[i], z, x, y);

        if (tileCache.containsKey(cacheKey)) {
          var tile = tileCache.get(cacheKey);

          if (tile.getState() === TileState.LOADED) {
            tile.endTransition(getUid(this));
            addTileToLookup(tilesByZ, tile, z);
            return true;
          }
        }
      }

      return false;
    }
    /**
     * Look for tiles covering the provided tile coordinate at an alternate
     * zoom level.  Loaded tiles will be added to the provided tile texture lookup.
     * @param {import("../../tilegrid/TileGrid.js").default} tileGrid The tile grid.
     * @param {import("../../tilecoord.js").TileCoord} tileCoord The target tile coordinate.
     * @param {number} altZ The alternate zoom level.
     * @param {TileLookup} tilesByZ Lookup of tiles by zoom level.
     * @return {boolean} The tile coordinate is covered by loaded tiles at the alternate zoom level.
     * @private
     */

  }, {
    key: "findAltTiles_",
    value: function findAltTiles_(tileGrid, tileCoord, altZ, tilesByZ) {
      var tileRange = tileGrid.getTileRangeForTileCoordAndZ(tileCoord, altZ, this.tempTileRange_);

      if (!tileRange) {
        return false;
      }

      var covered = true;
      var tileCache = this.tileCache_;
      var source = this.getLayer().getRenderSource();
      var sourceKey = source.getKey();

      for (var x = tileRange.minX; x <= tileRange.maxX; ++x) {
        for (var y = tileRange.minY; y <= tileRange.maxY; ++y) {
          var cacheKey = getCacheKey(sourceKey, altZ, x, y);
          var loaded = false;

          if (tileCache.containsKey(cacheKey)) {
            var tile = tileCache.get(cacheKey);

            if (tile.getState() === TileState.LOADED) {
              addTileToLookup(tilesByZ, tile, altZ);
              loaded = true;
            }
          }

          if (!loaded) {
            covered = false;
          }
        }
      }

      return covered;
    }
    /**
     * Render the layer.
     *
     * The frame rendering logic has three parts:
     *
     *  1. Enqueue tiles
     *  2. Find alt tiles for those that are not yet loaded
     *  3. Render loaded tiles
     *
     * @param {import("../../Map.js").FrameState} frameState Frame state.
     * @param {HTMLElement} target Target that may be used to render content to.
     * @return {HTMLElement} The rendered element.
     * @override
     */

  }, {
    key: "renderFrame",
    value: function renderFrame(frameState, target) {
      var _this2 = this;

      this.renderComplete = true;
      /**
       * TODO:
       *  * maybe skip transition when not fully opaque
       *  * decide if this.renderComplete is useful
       */

      var layerState = frameState.layerStatesArray[frameState.layerIndex];
      var viewState = frameState.viewState;
      var projection = viewState.projection;
      var viewResolution = viewState.resolution;
      var viewCenter = viewState.center;
      var pixelRatio = frameState.pixelRatio;
      var tileLayer = this.getLayer();
      var tileSource = tileLayer.getSource();
      var sourceRevision = tileSource.getRevision();
      var tileGrid = tileSource.getTileGridForProjection(projection);
      var z = tileGrid.getZForResolution(viewResolution, tileSource.zDirection);
      var tileResolution = tileGrid.getResolution(z);
      var sourceKey = tileSource.getKey();

      if (!this.renderedSourceKey_) {
        this.renderedSourceKey_ = sourceKey;
      } else if (this.renderedSourceKey_ !== sourceKey) {
        this.prependStaleKey(this.renderedSourceKey_);
        this.renderedSourceKey_ = sourceKey;
      }

      var frameExtent = frameState.extent;
      var tilePixelRatio = tileSource.getTilePixelRatio(pixelRatio);
      this.prepareContainer(frameState, target); // desired dimensions of the canvas in pixels

      var width = this.context.canvas.width;
      var height = this.context.canvas.height;
      var layerExtent = layerState.extent && fromUserExtent(layerState.extent, projection);

      if (layerExtent) {
        frameExtent = getIntersection(frameExtent, fromUserExtent(layerState.extent, projection));
      }

      var dx = tileResolution * width / 2 / tilePixelRatio;
      var dy = tileResolution * height / 2 / tilePixelRatio;
      var canvasExtent = [viewCenter[0] - dx, viewCenter[1] - dy, viewCenter[0] + dx, viewCenter[1] + dy];
      /**
       * @type {TileLookup}
       */

      var tilesByZ = {};
      this.renderedTiles.length = 0;
      /**
       * Part 1: Enqueue tiles
       */

      var preload = tileLayer.getPreload();

      if (frameState.nextExtent) {
        var targetZ = tileGrid.getZForResolution(viewState.nextResolution, tileSource.zDirection);
        var nextExtent = getRenderExtent(frameState, frameState.nextExtent);
        this.enqueueTiles(frameState, nextExtent, targetZ, tilesByZ, preload);
      }

      var renderExtent = getRenderExtent(frameState, frameExtent);
      this.enqueueTiles(frameState, renderExtent, z, tilesByZ, 0);

      if (preload > 0) {
        setTimeout(function () {
          _this2.enqueueTiles(frameState, renderExtent, z - 1, tilesByZ, preload - 1);
        }, 0);
      }

      if (!(z in tilesByZ)) {
        return this.container;
      }
      /**
       * Part 2: Find alt tiles for those that are not yet loaded
       */


      var uid = getUid(this);
      var time = frameState.time; // look for cached tiles to use if a target tile is not ready

      var _iterator = _createForOfIteratorHelper(tilesByZ[z]),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _tile = _step.value;

          var tileState = _tile.getState();

          if ((_tile instanceof ReprojTile || _tile instanceof ReprojDataTile) && tileState === TileState.EMPTY) {
            continue;
          }

          var _tileCoord = _tile.tileCoord;

          if (tileState === TileState.LOADED) {
            var alpha = _tile.getAlpha(uid, time);

            if (alpha === 1) {
              // no need to look for alt tiles
              _tile.endTransition(uid);

              continue;
            }
          }

          this.renderComplete = false;
          var hasStaleTile = this.findStaleTile_(_tileCoord, tilesByZ);

          if (hasStaleTile) {
            // use the stale tile before the new tile's transition has completed
            removeTileFromLookup(tilesByZ, _tile, z);
            frameState.animate = true;
            continue;
          } // first look for child tiles (at z + 1)


          var coveredByChildren = this.findAltTiles_(tileGrid, _tileCoord, z + 1, tilesByZ);

          if (coveredByChildren) {
            continue;
          } // next look for parent tiles


          var minZoom = tileGrid.getMinZoom();

          for (var parentZ = z - 1; parentZ >= minZoom; --parentZ) {
            var coveredByParent = this.findAltTiles_(tileGrid, _tileCoord, parentZ, tilesByZ);

            if (coveredByParent) {
              break;
            }
          }
        }
        /**
         * Part 3: Render loaded tiles
         */

      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var canvasScale = tileResolution / viewResolution * pixelRatio / tilePixelRatio;
      var context = this.getRenderContext(frameState); // set scale transform for calculating tile positions on the canvas

      composeTransform(this.tempTransform, width / 2, height / 2, canvasScale, canvasScale, 0, -width / 2, -height / 2);

      if (layerState.extent) {
        this.clipUnrotated(context, frameState, layerExtent);
      }

      if (!tileSource.getInterpolate()) {
        context.imageSmoothingEnabled = false;
      }

      this.preRender(context, frameState);
      /** @type {Array<number>} */

      var zs = Object.keys(tilesByZ).map(Number);
      zs.sort(ascending);
      var currentClip;
      var clips = [];
      var clipZs = [];

      for (var i = zs.length - 1; i >= 0; --i) {
        var currentZ = zs[i];
        var currentTilePixelSize = tileSource.getTilePixelSize(currentZ, pixelRatio, projection);
        var currentResolution = tileGrid.getResolution(currentZ);
        var currentScale = currentResolution / tileResolution;

        var _dx = currentTilePixelSize[0] * currentScale * canvasScale;

        var _dy = currentTilePixelSize[1] * currentScale * canvasScale;

        var originTileCoord = tileGrid.getTileCoordForCoordAndZ(getTopLeft(canvasExtent), currentZ);
        var originTileExtent = tileGrid.getTileCoordExtent(originTileCoord);
        var origin = applyTransform(this.tempTransform, [tilePixelRatio * (originTileExtent[0] - canvasExtent[0]) / tileResolution, tilePixelRatio * (canvasExtent[3] - originTileExtent[3]) / tileResolution]);
        var tileGutter = tilePixelRatio * tileSource.getGutterForProjection(projection);

        var _iterator2 = _createForOfIteratorHelper(tilesByZ[currentZ]),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var tile = _step2.value;

            if (tile.getState() !== TileState.LOADED) {
              continue;
            }

            var tileCoord = tile.tileCoord; // Calculate integer positions and sizes so that tiles align

            var xIndex = originTileCoord[1] - tileCoord[1];
            var nextX = Math.round(origin[0] - (xIndex - 1) * _dx);
            var yIndex = originTileCoord[2] - tileCoord[2];
            var nextY = Math.round(origin[1] - (yIndex - 1) * _dy);
            var x = Math.round(origin[0] - xIndex * _dx);
            var y = Math.round(origin[1] - yIndex * _dy);
            var w = nextX - x;
            var h = nextY - y;
            var transition = zs.length === 1;
            var contextSaved = false; // Clip mask for regions in this tile that already filled by a higher z tile

            currentClip = [x, y, x + w, y, x + w, y + h, x, y + h];

            for (var _i = 0, ii = clips.length; _i < ii; ++_i) {
              if (!transition && currentZ < clipZs[_i]) {
                var clip = clips[_i];

                if (intersects([x, y, x + w, y + h], [clip[0], clip[3], clip[4], clip[7]])) {
                  if (!contextSaved) {
                    context.save();
                    contextSaved = true;
                  }

                  context.beginPath(); // counter-clockwise (outer ring) for current tile

                  context.moveTo(currentClip[0], currentClip[1]);
                  context.lineTo(currentClip[2], currentClip[3]);
                  context.lineTo(currentClip[4], currentClip[5]);
                  context.lineTo(currentClip[6], currentClip[7]); // clockwise (inner ring) for higher z tile

                  context.moveTo(clip[6], clip[7]);
                  context.lineTo(clip[4], clip[5]);
                  context.lineTo(clip[2], clip[3]);
                  context.lineTo(clip[0], clip[1]);
                  context.clip();
                }
              }
            }

            clips.push(currentClip);
            clipZs.push(currentZ);
            this.drawTile(tile, frameState, x, y, w, h, tileGutter, transition);

            if (contextSaved) {
              context.restore();
            }

            this.renderedTiles.unshift(tile); // TODO: decide if this is necessary

            this.updateUsedTiles(frameState.usedTiles, tileSource, tile);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }

      this.renderedRevision = sourceRevision;
      this.renderedResolution = tileResolution;
      this.extentChanged = !this.renderedExtent_ || !equals(this.renderedExtent_, canvasExtent);
      this.renderedExtent_ = canvasExtent;
      this.renderedPixelRatio = pixelRatio;
      this.renderedProjection = projection;
      this.postRender(this.context, frameState);

      if (layerState.extent) {
        context.restore();
      }

      context.imageSmoothingEnabled = true;
      /**
       * Here we unconditionally expire the source cache since the renderer maintains
       * its own cache.
       * @param {import("../../Map.js").default} map Map.
       * @param {import("../../Map.js").FrameState} frameState Frame state.
       */

      var postRenderFunction = function postRenderFunction(map, frameState) {
        var tileSourceKey = getUid(tileSource);
        var wantedTiles = frameState.wantedTiles[tileSourceKey];
        var tilesCount = wantedTiles ? Object.keys(wantedTiles).length : 0;

        _this2.updateCacheSize(tilesCount);

        _this2.tileCache_.expireCache();
      };

      frameState.postRenderFunctions.push(postRenderFunction);
      return this.container;
    }
    /**
     * Increases the cache size if needed
     * @param {number} tileCount Minimum number of tiles needed.
     */

  }, {
    key: "updateCacheSize",
    value: function updateCacheSize(tileCount) {
      this.tileCache_.highWaterMark = Math.max(this.tileCache_.highWaterMark, tileCount * 2);
    }
    /**
     * @param {import("../../Tile.js").default} tile Tile.
     * @param {import("../../Map.js").FrameState} frameState Frame state.
     * @param {number} x Left of the tile.
     * @param {number} y Top of the tile.
     * @param {number} w Width of the tile.
     * @param {number} h Height of the tile.
     * @param {number} gutter Tile gutter.
     * @param {boolean} transition Apply an alpha transition.
     * @protected
     */

  }, {
    key: "drawTile",
    value: function drawTile(tile, frameState, x, y, w, h, gutter, transition) {
      var image;

      if (tile instanceof DataTile) {
        image = asImageLike(tile.getData());

        if (!image) {
          throw new Error('Rendering array data is not yet supported');
        }
      } else {
        image = this.getTileImage(
        /** @type {import("../../ImageTile.js").default} */
        tile);
      }

      if (!image) {
        return;
      }

      var context = this.getRenderContext(frameState);
      var uid = getUid(this);
      var layerState = frameState.layerStatesArray[frameState.layerIndex];
      var alpha = layerState.opacity * (transition ? tile.getAlpha(uid, frameState.time) : 1);
      var alphaChanged = alpha !== context.globalAlpha;

      if (alphaChanged) {
        context.save();
        context.globalAlpha = alpha;
      }

      context.drawImage(image, gutter, gutter, image.width - 2 * gutter, image.height - 2 * gutter, x, y, w, h);

      if (alphaChanged) {
        context.restore();
      }

      if (alpha !== layerState.opacity) {
        frameState.animate = true;
      } else if (transition) {
        tile.endTransition(uid);
      }
    }
    /**
     * @return {HTMLCanvasElement} Image
     */

  }, {
    key: "getImage",
    value: function getImage() {
      var context = this.context;
      return context ? context.canvas : null;
    }
    /**
     * Get the image from a tile.
     * @param {import("../../ImageTile.js").default} tile Tile.
     * @return {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} Image.
     * @protected
     */

  }, {
    key: "getTileImage",
    value: function getTileImage(tile) {
      return tile.getImage();
    }
    /**
     * @param {!Object<string, !Object<string, boolean>>} usedTiles Used tiles.
     * @param {import("../../source/Tile.js").default} tileSource Tile source.
     * @param {import('../../Tile.js').default} tile Tile.
     * @protected
     */

  }, {
    key: "updateUsedTiles",
    value: function updateUsedTiles(usedTiles, tileSource, tile) {
      // FIXME should we use tilesToDrawByZ instead?
      var tileSourceKey = getUid(tileSource);

      if (!(tileSourceKey in usedTiles)) {
        usedTiles[tileSourceKey] = {};
      }

      usedTiles[tileSourceKey][tile.getKey()] = true;
    }
  }]);

  return CanvasTileLayerRenderer;
}(CanvasLayerRenderer);

export default CanvasTileLayerRenderer;